import { atom } from "recoil";

export interface TenantLocationState {
    paths: string[];
    pathsWithoutUuids: string[];
    full: string | null;
    fullWithSlug: string | null;
    locationTag: string | null;
}

export const tenantLocationAtom = atom<TenantLocationState>({
    key: "tenantLocationAtom",
    default: {
        paths: [],
        pathsWithoutUuids: [],
        full: null,
        fullWithSlug: null,
        locationTag: null,
    },
});
